import { useContext } from "react";
import {HTTPGenericResponse} from "../../constants/FinanceModels";
import {useApi} from "../Api";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import qs from "qs";
import {getFilterValue} from "../../utils/FilterUtils";
import {
    ID_FILTER_CONFIGURATION_DEALERS,
    ID_FILTER_CONFIGURATION_LEGAL_ENTITIES
} from "../../pages/enelx/constants/EnelxFilters";

export const useConfigurationRepository = () => {
    const { GET, PUT } = useApi();

    const PATH = "/finance/enel-x/configuration"

    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);           

    async function getConfiguration(filterDefs: any) {
        let legalEntities: string[] = getFilterValue(ID_FILTER_CONFIGURATION_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_CONFIGURATION_DEALERS, filterDefs);
        let params = {
            legalEntities, dealers
        }
        return GET(`${PATH}`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) }, true);
    }

    function updateConfiguration(configuration: any): Promise<HTTPGenericResponse> {
        configuration.forEach((conf: any) => {
            conf["kwhPrice"] =  convertAmount(conf["kwhPrice"]);
            conf["penaltyDurationPrice"] =  convertAmount(conf["penaltyDurationPrice"]);
            delete conf["dealer"];
            delete conf["legalEntity"];
        })

        return PUT(`${PATH}`, configuration, {}, true);
    }

    function convertAmount(value: number | string): number {
        // Converti il valore in una stringa, nel caso in cui non lo sia.
        let valueAsString = value.toString();

        // Determina il formato del numero basandosi sulla posizione dell'ultimo separatore (punto o virgola).
        const lastDotIndex = valueAsString.lastIndexOf('.');
        const lastCommaIndex = valueAsString.lastIndexOf(',');

        // Se l'ultimo separatore è una virgola, sostituisci tutte le virgole con il punto e rimuovi i punti come separatori delle migliaia.
        // Altrimenti, se l'ultimo separatore è un punto, rimuovi tutte le virgole (assumendo che siano separatori delle migliaia).
        if (lastCommaIndex > lastDotIndex) {
            // Il formato usa la virgola come separatore decimale.
            valueAsString = valueAsString.replace(/\./g, '').replaceAll(',', '.');
        } else {
            // Il formato usa il punto come separatore decimale.
            valueAsString = valueAsString.replace(/,/g, '');
        }

        // Converti il valore in un numero float e moltiplicalo per 100 per ottenere i centesimi.
        const cents = parseFloat(valueAsString)* 1000;

        // Arrotonda il risultato per evitare problemi di precisione dei numeri floating point e convertilo in un intero.
        return Math.round(cents);
    }

    return { getConfiguration, updateConfiguration };
}